import React, { useState, useEffect, Fragment } from 'react';
import { BrowserRouter as Router, Switch, Route, Link, useHistory, Redirect, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Spinner, Modal } from 'react-bootstrap'
import './index.scss';
import SearchIcon from "@material-ui/icons/Search";
import "antd/dist/antd.min.css";
import { useSelector } from 'react-redux'
import { useFetchQuery, useStoreListQuery, useCreateMutation, useUpdateMutation, useAbortMutation, useStartMutation } from '../../services/create_products';
import Moment from 'moment';
import Button from '@mui/material/Button';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import LinearProgress from '@mui/material/LinearProgress';
import { Tag } from 'antd';

function CreateProducts() {
  const { userId, userToken, userEmail, userName, isStatus, userRole, languageCode, isAdmin } = useSelector((state) => state.auth);
  const history = useHistory();
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const location = useLocation();
  const page = new URLSearchParams(location.search).get('page') || 1
  const limit = new URLSearchParams(location.search).get('size') || 15


  const [getSearchId, setSearchId] = useState("")
  const [getNewModal, setNewModal] = useState(false)
  const [getOthersModal, setOthersModal] = useState(false)
  const [getName, setName] = useState('')
  const [getUsername, setUsername] = useState('')
  const [getReference, setReference] = useState('')

  const othersUserData = {
    name: getName,
    username: getUsername,
    reference: getReference
  }

  const dataInfo = useFetchQuery({
    page: page,
    size: limit,
    searchid: getSearchId,
    userId: userId,
    userToken: userToken,
    userRole: userRole
  }, { count: 1 }, { refetchOnMountOrArgChange: true })
  const results = dataInfo?.data?.results;
  const pagination = dataInfo?.data?.pagination;


  const storeListData = useStoreListQuery({
    page: page,
    size: limit,
    searchid: getSearchId,
    userId: userId,
    userToken: userToken,
    userRole: userRole
  }, { count: 1 }, { refetchOnMountOrArgChange: true })
  const activeStore = storeListData?.data?.stores?.active;
  const draftStore = storeListData?.data?.stores?.draft;


  const [createUser, createresult] = useCreateMutation()
  const [abortquery, abortqueryresult] = useCreateMutation()
  const [startquery, startqueryresult] = useStartMutation()
  const [getJobType, setJobType] = useState("")

  async function createFunction(data) {
    const active = await activeStore?.find(obj => obj.id === Number(data?.to_store));
    const draft = await draftStore?.find(obj => obj.id === Number(data?.from_store));
    createUser({
      type: getJobType,
      from_store: data?.from_store,
      from_store_name: draft?.name,
      to_store: data?.to_store,
      to_store_name: active?.name,
      limits: data?.limits,
      userId: userId,
      userToken: userToken,
      userRole: userRole
    })
  }

  function ebtidaEModal() {
    setNewModal(true)
  }
  function closeNewModal() {
    setNewModal(false)
  }

  useEffect(() => {
    if (createresult?.isSuccess) {
      setNewModal(false)
      setOthersModal(false)
      reset()
    }

  }, [createresult]);


  function getLoadingProgress(thisLoading, thisFetching) {
    if (thisLoading) {
      return true
    } else if (thisFetching) {
      return true
    } else {
      return false
    }
  }

  function getStatusName(status) {
    if (status === 'finished') {
      return { color: 'success', name: 'Finished', variant: 'outlined' }
    } else if (status === 'in_progress') {
      return { color: 'warning', name: 'In-progress', variant: 'outlined' }
    } else if (status === 'cancelled') {
      return { color: 'error', name: 'Cancelled', variant: 'outlined' }
    } else {
      return { color: 'info', name: 'Start', variant: 'outlined' }
    }
  }

  function buttonDisabled(status) {
    if (startqueryresult?.isLoading) {
      return true
    } else {
      if (status === 'finished') {
        return true
      } else if (status === 'in_progress') {
        return true
      } else if (status === 'cancelled') {
        return true
      } else {
        return false
      }
    }
  }


  return (
    <div className="tabel_cards">

      <Modal className="user-page-modal" show={getNewModal} onHide={closeNewModal} animation={false}>
        {/* <Modal.Header closeButton>
          <Modal.Title>New</Modal.Title>
        </Modal.Header> */}
        <Modal.Body>

          <IconButton
            style={{ cursor: 'pointer', position: 'absolute', right: '10px', top: '10px', zIndex: 111 }}
            onClick={closeNewModal}
          >
            <CloseIcon className="Header-close-modal-icon" />
          </IconButton>
          <div className="row">
            <div className="col-md-12">
              <h5 style={{ textAlign: 'center', padding: '10px' }}>New</h5>
            </div>
          </div>
          <form onSubmit={handleSubmit(createFunction)}>
            {createresult?.error?.data?.error &&
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px' }}>
                <span className="alert alert-danger">{createresult?.error?.data?.error}</span>
              </div>
            }
            <div className="row">

              <div className="col-md-12">
                <div className="form-group">
                  <label>From Draft Store</label>
                  <select
                    required
                    style={{ height: '45px' }} onChange={(e) => setJobType(e.target.value)}
                    className='form-control'>
                    <option selected disabled>Select</option>
                    <option value={'create'}>Create Products</option>
                    <option value={'refetch'}>Refetch Products</option>
                  </select>
                </div>
              </div>


              <div className="col-md-12">
                <div className="form-group">
                  <label>From Draft Store</label>
                  <select disabled={getJobType === 'create' ? false : true} style={{ height: '45px' }} className='form-control' id="from_store"
                    aria-invalid={errors.from_store ? "true" : "false"}
                    {...register('from_store', { required: false })}>
                    <option selected disabled>Select</option>
                    {draftStore?.map((item, i) =>
                      <option value={item.id}>{item.name}</option>
                    )}
                  </select>
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <label>To Active Store</label>
                  <select style={{ height: '45px' }} className='form-control' id="to_store"
                    aria-invalid={errors.to_store ? "true" : "false"}
                    {...register('to_store', { required: true })}>
                    <option selected disabled>Select</option>
                    {activeStore?.map((item, i) =>
                      <option value={item.id}>{item.name}</option>
                    )}
                  </select>
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <label>Limits</label>
                  <input style={{ height: '45px' }} type="text" className="form-control"
                    id="limits"
                    aria-invalid={errors.limits ? "true" : "false"}
                    {...register('limits', { required: true })}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group" style={{ justifyContent: 'flex-end', display: 'flex' }}>
                  <Button
                    style={{ width: 'auto', height: '40px', background: '#222d45', color: '#eee' }}
                    disabled={createresult.isLoading ? true : false}
                    color="info"
                    variant="contained"
                    size="small"
                    type="submit">
                    {createresult.isLoading ? 'Loading...' : 'Create'}
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>


      <div className="row" style={{ margin: 0, padding: 0 }}>
        <div className="newFlexPagi">
          <div className="col-md-12">
            <div className="storeCardB">
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', overflow: 'auto', width: '100%', whiteSpace: 'nowrap' }}>
                <div>Showing {pagination?.totalCounts && pagination?.totalCounts} entries</div>
                <div className="Order-Pagination">

                  <Pagination
                    className='list-paginatiion-table'
                    style={{ width: '100%', textAlign: 'right', display: 'flex', justifyContent: 'flex-end', padding: '0px' }}
                    page={parseInt(page)}
                    count={parseInt(pagination?.totalPages)}
                    color="primary"
                    variant="outlined"
                    shape="rounded"
                    disabled={dataInfo?.isLoading ? true : false}
                    renderItem={(item) => (
                      <PaginationItem
                        component={Link}
                        to={{
                          pathname: `${window.location.pathname}`,
                          search: `?page=${parseInt(item.page)}`
                        }}
                        {...item}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row" style={{ margin: 0, padding: 0 }}>
        <div className="col-md-12" style={{ padding: 0 }}>
          <div className="storeCardB">
            <div className="updateButton">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ position: 'relative', marginRight: '10px' }}>
                  <input style={{ borderRadius: '100px' }} className="form-control table_search" placeholder="Search..." onChange={(e) => setSearchId(e.target.value)} />
                  {/* {dataInfo?.isFetching &&
                    <Spinner style={{ width: '1rem', height: '1rem', fontSize: '7px', position: 'absolute', top: '12px', right: '40px', color: '#cbcbcb' }} animation="border" />
                  } */}
                  <SearchIcon className="table_search_icon" />
                </div>
              </div>
              <div className="table_search_card">
                <div>
                  <Button
                    // style={{background: '#4e5053'}}
                    style={{ border: '0.5px solid #4e5053', color: '#4e5053' }}
                    variant="outlined"
                    size="small"
                    onClick={() => ebtidaEModal()}>
                    Add New
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row" style={{ margin: 0, padding: 0 }}>
        <div className="col-md-12" style={{ padding: 0 }}>
          <div className="tabelOverflow" style={{ position: 'relative' }}>
            {getLoadingProgress(dataInfo?.isLoading, dataInfo?.isFetching) &&
              <div className='loading-progress-bg' style={{ position: 'absolute', top: 0, right: 0, left: 0, zIndex: 222, height: '100%', background: '#ffffff82' }}>
                <LinearProgress style={{ height: '2px' }} />
              </div>
            }
            <table className="table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Type</th>
                  <th>From Store</th>
                  <th>To Store</th>
                  <th>Limit</th>
                  <th>Processed</th>
                  <th>UpdateAt</th>
                  <th className="sticky-column" style={{ textAlign: 'right' }}>
                    Status
                  </th>
                </tr>
              </thead>
              {results?.length === 0 ?
                <h5 className="data_not-found">No data available</h5>
                : null}
              <tbody>
                {results?.map((item, i) =>
                  <tr key={i}>
                    <td>
                      <div>{item.id}</div>
                    </td>
                    <td>
                      <div><Tag>{item.type}</Tag></div>
                    </td>
                    <td>
                      <div>{item.from_store_name}&nbsp; <Tag>{item.from_store}</Tag></div>
                    </td>
                    <td>
                      <div>{item.to_store_name}&nbsp; <Tag>{item.to_store}</Tag></div>
                    </td>
                    <td>
                      <div>{item.limits}</div>
                    </td>
                    <td>
                      <div>{item.processed}</div>
                    </td>
                    <td>
                      <div>{Moment(item.createdAt).format('DD-MM-YYYY')}</div>
                    </td>
                    <td className="sticky-column" style={{ textAlign: 'right' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                        <Button
                          disabled={buttonDisabled(item.status)}
                          color={getStatusName(item.status)?.color}
                          variant={getStatusName(item.status)?.variant}
                          size="small"
                          type="submit"
                          onClick={(() => startquery({
                            id: item.id,
                            from_store: item.from_store,
                            to_store: item.to_store,
                            userId: userId,
                            userToken: userToken,
                            userRole: userRole
                          }))}
                        >
                          {getStatusName(item.status)?.name}
                        </Button>

                        <Button
                          disabled={item.status !== 'in_progress'}
                          style={{ margin: '0px 10px' }}
                          color="error"
                          variant="outlined"
                          size="small"
                          type="submit"
                          onClick={(() => (abortquery({
                            id: item.id,
                            thread_id: item.thread_id,
                            userId: userId,
                            userToken: userToken,
                            userRole: userRole
                          })))}
                        >
                          Abort
                        </Button>
                      </div>
                    </td>
                  </tr>
                )
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {!dataInfo?.isLoading &&
        <>
          {dataInfo?.error?.originalStatus === 403 &&
            <div className="row reject-bottom-message" style={{ margin: 0, padding: 0, justifyContent: 'center' }}>
              <div className="col-md-6" style={{ padding: 0 }}>
                <div className='alert alert-warning' style={{ textAlign: 'center' }}>{dataInfo?.error?.data}</div>
              </div>
            </div>
          }
        </>
      }
    </div>
  );
}

export default CreateProducts;
